export default __webpack_public_path__ + "static/media/money-bag.df35a747.svg";